import { createSelector } from 'reselect';

const selectApplications = (state: any) => state.applications;


export const selectApplicationsCurrentItem = createSelector([selectApplications], (applications) => applications.current);

export const selectApplicationsListItems = createSelector([selectApplications], (applications) => applications.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectApplicationsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectApplicationsQueryItems = createSelector([selectApplications], (applications) => applications.query);

export const selectApplicationsCreatedItem = createSelector([selectApplications], (applications) => applications.create);

export const selectApplicationsUpdatedItem = createSelector([selectApplications], (applications) => applications.update);

export const selectApplicationsReadItem = createSelector([selectApplications], (applications) => applications.read);

export const selectApplicationsDeletedItem = createSelector([selectApplications], (applications) => applications.delete);

export const selectApplicationsSearchedItems = createSelector([selectApplications], (applications) => applications.search);

export const selectApplicationsItemsCount = createSelector([selectApplications], (applications) => applications.count);

export const selectApplicationsItemsFilter = createSelector([selectApplications], (applications) => applications.filter);